module.exports = "/_next/static/images/android-icon-192x192-f12285e5c892694a6c7c37beddabe3e3.png";